import {
  FETCH_ALL_TRANSACTIONS,
  FETCH_ALL_TRANSACTIONS_SUCCESS,
  FETCH_ALL_TRANSACTIONS_FAILED,
  EDIT_TRANSACTION_SUCCESS,
  EDIT_TRANSACTION,
  EDIT_TRANSACTION_FAILED
} from "../store/types";

export const INITIAL_STATE = {
  transactions: null,
  loading: false,
  load: false,
  error: {
    flag: false,
    msg: null
  }
}

export const transreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ALL_TRANSACTIONS:
      return {
        ...state,
        loading: true,
      };
    case EDIT_TRANSACTION:
      return {
        ...state,
        loading: true,
      };
    case EDIT_TRANSACTION_FAILED:
      return {
        ...state,
        loading: false,
        load:false
      };
    case EDIT_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        load: true
      };
    case FETCH_ALL_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactions: action.payload,
        loading: false
      };
    case FETCH_ALL_TRANSACTIONS_FAILED:
      return {
        ...state,
        transactions: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    default:
      return state;
  }
};